import { render, staticRenderFns } from "./component.vue?vue&type=template&id=4cbc0be6&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=4cbc0be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc0be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cbc0be6')) {
      api.createRecord('4cbc0be6', component.options)
    } else {
      api.reload('4cbc0be6', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=4cbc0be6&scoped=true&", function () {
      api.rerender('4cbc0be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/resource/component/core/custom-dropdown/component.vue"
export default component.exports